import {
  ArrowRight20,
  DataView24,
  DocumentDownload16,
  DocumentDownload24,
  Edit24,
  SendAlt24,
} from "@carbon/icons-react";
import { Search32 } from "@carbon/icons-react";
import { Add16 } from "@carbon/icons-react";
import { ButtonSet, Form } from "carbon-components-react";
import {
  Row,
  Column,
  TextInput,
  Button,
  DataTable,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableHeader,
  TableRow,
  TableToolbar,
  TableToolbarContent,
} from "carbon-components-react";
import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { Link, useNavigate } from "react-router-dom";
import SubmitButton from "../../components/Buttons/SubmitButton";
import Card from "../../components/Card/Card";
import TablePagination from "../../components/Pagination/Pagination";
import http from "../../http-common";
import { saveAs } from "file-saver";

const tableHeaders = [
  {
    header: "Vaga",
    key: "vacancyTitle",
  },
  {
    header: "Nome",
    key: "name",
  },
  {
    header: "Telefone",
    key: "phoneNumber",
  },
  {
    header: "Sexo",
    key: "gender",
  },
  {
    header: "Total",
    key: "totalScore",
  },
  // {
  //   header: " ",
  //   key: "actions",
  // },
];

const LinkList = ({ url, url2, isOpen }) => (
  <ul style={{ display: "flex" }}>
    <li>
      <Link to={url2} title="Visualizar">
        <DataView24 />
      </Link>
    </li>
  </ul>
);

const getCellContent = (cell, id) => {
  if (cell.info.header === "actions") {
    return (
      <LinkList
        url={"../editar-candidatura/" + id}
        url2={"../visualizar-candidatura/" + id}
      />
    );
  }
  return cell.value;
};

const TraineeRankingPage = () => {
  const [apps, setApps] = useState([]);
  const [count, setCount] = useState(0);
  const [size, setSize] = useState(20);

  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();

  const featchData = async () => {
    try {
      const response = await http.get(
        "/internships/trainees/score/search/q?size=" + size
      );
      getApplicationData(response);
    } catch (error) {
      console.log(error);
    }
  };

  const onPageChange = async ({ page, pageSize }) => {
    try {
      var pag = page - 1;
      const response = await http.get(
        "/internships/trainees/score/search/q?page=" + pag + "&size=" + pageSize
      );
      getApplicationData(response);
    } catch (error) {}
  };

  const onSearch = async (data) => {
    try {
      const response = await http.get(
        `/internships/trainees/score/search/q?trainee.name=${data.name}&trainee.phoneNumber1=${data.phoneNumber1}`
      );
      getApplicationData(response);
    } catch (error) {}
  };

  const getApplicationData = (response) => {
    const data = response.data.content.map((score) => ({
      id: score.id.toString(),
      vacancyTitle: score.vacancyTitle,
      name: score.traineeName,
      phoneNumber: score.traineePhoneNumber1,
      gender: score.traineeGender,
      totalScore: score.total
        ? ((score.total / 20) * 100).toFixed(2) + "%"
        : "",
    }));
    setApps(data);
    setCount(response.data.totalElements);
  };

  useEffect(() => {
    featchData();
  }, []);

  const onExportToExcel = async () => {
    try {
      const response = await http.get(`/applications/export-evaluations`);
      let url = window.URL.createObjectURL(response.data);
      let a = document.createElement("a");
      a.href = url;
      a.download = "employees.xlsx";
      a.click();
    } catch (error) {}
  };

  return (
    <Card title="Ranking de Candidaturas para estágio">
      {/* <Button
        kind="ghost"
        size="sm"
        onClick={downloadEmployeeData}
        className="mb-2"
      >
        <DocumentDownload16 /> Exportar
      </Button> */}
      <DataTable rows={apps} headers={tableHeaders} isSortable useZebraStyles>
        {({ rows, headers, getHeaderProps, getTableProps }) => (
          <TableContainer>
            <TableToolbar aria-label="data table toolbar">
              <TableToolbarContent>
                {/* <TableToolbarSearch
                  placeholder="Digite o número de telefone para pesquisar"
                  onChange={(e) => search(e.target.value)}
                /> */}
                <Form
                  className="data-table-search-form"
                  onSubmit={handleSubmit(onSearch)}
                >
                  <Row>
                    <Column sm={6} md={4} lg={4}>
                      <TextInput
                        id="name"
                        labelText=""
                        placeholder="Nome"
                        {...register("name")}
                      />
                    </Column>
                    <Column sm={6} md={3} lg={3}>
                      <TextInput
                        id="phoneNumber1"
                        labelText=""
                        placeholder="Telefone"
                        {...register("phoneNumber1")}
                      />
                    </Column>
                  </Row>
                  <Button type="submit" renderIcon={Search32}>
                    Pesquisar
                  </Button>
                </Form>
              </TableToolbarContent>
            </TableToolbar>
            <Table {...getTableProps()}>
              <TableHead>
                <TableRow>
                  {headers.map((header) => (
                    <TableHeader {...getHeaderProps({ header })}>
                      {header.header}
                    </TableHeader>
                  ))}
                </TableRow>
              </TableHead>
              <TableBody>
                {rows.map((row) => (
                  <TableRow key={row.id}>
                    {row.cells.map((cell) => (
                      <TableCell key={cell.id}>
                        {getCellContent(cell, row.id)}
                      </TableCell>
                    ))}
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        )}
      </DataTable>
      <TablePagination
        currentPageSize={size}
        onPageChange={onPageChange}
        totalItems={count}
      />
    </Card>
  );
};

export default TraineeRankingPage;
